export default {
      id: "icon-zoom-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#icon-zoom",
      toString: function () {
        return this.url;
      }
    }